import { createFeatureSelector, createSelector } from "@ngrx/store";
import { OVERVIEW_LOCATIONS, OverviewLocationsState } from "./locations.reducer";

const getOverviewLocationsState = createFeatureSelector<OverviewLocationsState>(OVERVIEW_LOCATIONS);

export const getOverviewLocations = createSelector(getOverviewLocationsState, (state: OverviewLocationsState) => state.location);

export const areLocationsLoaded = createSelector(getOverviewLocationsState, (state: OverviewLocationsState) => state.loaded);
